'use client';

import type { Session } from 'next-auth';
import { useState, useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { trpc } from '@backend/trpc/client';
// import LoginPage from './(root)/login/page'
import { Loading } from './loading';
type AppPropsWithSlot = {
  children: React.ReactNode;
  session: Session | null;
  app: React.ReactNode;
  portal: React.ReactNode;
};
export const App = ({
  children,
  session,
  app,
  portal
}: AppPropsWithSlot) => {
  // console.log('session', session)
  const pathname = usePathname();
  if (pathname.includes('/about') || pathname.includes('/test') || pathname.includes('/share') ||
  // pathname.includes('/chip') ||
  // pathname.includes('/helloWorld') ||
  pathname.includes('/login')) {
    return children;
  }
  const [isLoading, setIsLoading] = useState(true);
  const [haveSession, setHaveSession] = useState(false);
  const {
    mutate
  } = trpc.user.session.isValidSession.useMutation({
    onSuccess: data => {
      if (session && data && data.isSession) {
        setIsLoading(false);
        setHaveSession(true);
      } else {
        setIsLoading(false);
        setHaveSession(false);
      }
    }
  });
  useEffect(() => {
    mutate();
  }, [mutate]);
  if (isLoading) return <Loading />;
  return <>{haveSession ? app : portal}</>;
};